/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Nav_RequestsInputs */

const en_portal_nav_requests = /** @type {(inputs: Portal_Nav_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requests`)
};

/** @type {(inputs: Portal_Nav_RequestsInputs) => LocalizedString} */
const ar_portal_nav_requests = en_portal_nav_requests;

/** @type {(inputs: Portal_Nav_RequestsInputs) => LocalizedString} */
const he_portal_nav_requests = en_portal_nav_requests;

/** @type {(inputs: Portal_Nav_RequestsInputs) => LocalizedString} */
const ur_portal_nav_requests = en_portal_nav_requests;

/** @type {(inputs: Portal_Nav_RequestsInputs) => LocalizedString} */
const es_portal_nav_requests = en_portal_nav_requests;

/** @type {(inputs: Portal_Nav_RequestsInputs) => LocalizedString} */
const fr_portal_nav_requests = en_portal_nav_requests;

/** @type {(inputs: Portal_Nav_RequestsInputs) => LocalizedString} */
const de_portal_nav_requests = en_portal_nav_requests;

/** @type {(inputs: Portal_Nav_RequestsInputs) => LocalizedString} */
const pt_portal_nav_requests = en_portal_nav_requests;

/** @type {(inputs: Portal_Nav_RequestsInputs) => LocalizedString} */
const hi_portal_nav_requests = en_portal_nav_requests;

/** @type {(inputs: Portal_Nav_RequestsInputs) => LocalizedString} */
const bn_portal_nav_requests = en_portal_nav_requests;

/**
* | output |
* | --- |
* | "Requests" |
*
* @param {Portal_Nav_RequestsInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portal_nav_requests = /** @type {((inputs?: Portal_Nav_RequestsInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Nav_RequestsInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portal_nav_requests(inputs)
	if (locale === "he") return he_portal_nav_requests(inputs)
	if (locale === "ur") return ur_portal_nav_requests(inputs)
	if (locale === "es") return es_portal_nav_requests(inputs)
	if (locale === "fr") return fr_portal_nav_requests(inputs)
	if (locale === "de") return de_portal_nav_requests(inputs)
	if (locale === "pt") return pt_portal_nav_requests(inputs)
	if (locale === "hi") return hi_portal_nav_requests(inputs)
	if (locale === "bn") return bn_portal_nav_requests(inputs)
	return /** @type {LocalizedString} */ ("Requests")
});